module.exports = __webpack_public_path__ + "static/Designed_for_Adobe_Photoshop_badge-1c0b2b50a46d32e51e8c56ef709611fc.png";